import { Block } from "baseui/block";
import { themedUseStyletron } from "../../../theme/customTheme";
import { OperationHours } from "../Aggregate/OperationHours";
import { LastXDaysLabel } from "../SensorDigital/LastXDaysLabel";
import { ObjectBooleanTimeline } from "../../../features/Charts/ObjectBooleanTimeline";
import { getTimeRangeFromTimespan } from "../../../utils/timeUtils";
import { IDriveVarSpeed } from "./types";
import { TimeSeriesLineChart } from "../../../features/Charts/LineCharts/TimeSeriesLineChart";
import { useIntl } from "react-intl";


const InsightsPanel = (props: IDriveVarSpeed) => {
    const [css, theme] = themedUseStyletron()
    const intl = useIntl();
    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);
    return (<>
        {props.operationHours > 0 && <OperationHours {...props}></OperationHours>}
        <Block marginTop={theme.sizing.scale800}></Block>
        <LastXDaysLabel days={7}></LastXDaysLabel>
        <ObjectBooleanTimeline currentValue={props.isOn} onColor={theme.appColors.aggregate.on} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isOn'}></ObjectBooleanTimeline>
        <TimeSeriesLineChart
                        showLegend={true}
                        enableZoom
                        timespan={2 * 24 * 60}
                        lines={[
                            { label: intl.formatMessage({ id: "Devices.ActualSpeed", defaultMessage: "Actual Speed" }), lineColor: theme.appColors.aggregate.actualValue, objectId: props.id, resourceGroupId: props.resourceGroupId, propertyName: 'actSpeed', currentValue: props.actSpeed, yScaleId: 'y', fill: true, stepped: false, showPoints: false },
                            { label: intl.formatMessage({ id: "Devices.Setpoint", defaultMessage: "Setpoint" }), lineColor: theme.appColors.aggregate.setpoint, objectId: props.id, resourceGroupId: props.resourceGroupId, propertyName: 'setSpeed', currentValue: props.setSpeed, stepped: true, fill: false, showPoints: false },
                        ]}
                        summarizeBy={'1s'}
                        showAverage={false}></TimeSeriesLineChart>

    </>)
}

export default InsightsPanel